export enum PromotionApplicationStatus{
  Pending = 0,
  Approved,
  Rejected
}
